<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      Inventory Log
    </portal>
    <card cols="12" title="Inventory Log">
      <hm-card-inner>
        <hm-input-select v-model="roomTypeId" label="Room Type" cols="12 2@hd 2@desktop 6@tablet" @input="refreshLog">
          <option v-for="item in hotelSettings.roomTypes.all()" :value="item.id">{{ item.name[$shortLocale] }}</option>
        </hm-input-select>
        <hm-input-date ref="startDate"
                       v-model="startDate"
                       label="From"
                       cols="12 2@hd 2@desktop 6@tablet"
                       name="startDate"
                       @input="refreshLog" />
        <hm-input-date ref="endDate"
                       v-model="endDate"
                       :min-date="startDate"
                       :min-date-inclusive="true"
                       :max-days="14"
                       :max-date="maxDate"
                       label="Until"
                       cols="12 2@hd 2@desktop 6@tablet"
                       name="endDate"
                       @input="refreshLog" />
      </hm-card-inner>
      <template v-if="!isNil(updateLog)">
        <hm-card-inner v-for="date in dates" :title="`${date}`" :key="date">
          <!--          &lt;!&ndash;            <hm-input :value="entry.inventory"&ndash;&gt;-->
          <!--          &lt;!&ndash;                      :disabled="true"&ndash;&gt;-->
          <!--          &lt;!&ndash;                      label="Inventory"&ndash;&gt;-->
          <!--          &lt;!&ndash;                      cols="12 6@tablet 3@dekstop 2@hd start-1"/>&ndash;&gt;-->
          <!--          <hm-col :grid="true" cols="12 6@desktop 4@hd start-1">-->
          <!--            <label-value-dotted :value="entry.inventory" label="Inventory" />-->
          <!--            <label-value-dotted v-for="rate in entry.rate" :value="`${ $options.filters.toCurrency(parseFloat(rate.rate)) }&nbsp;${ hotelSettings.details.currency }`" :label="`${ rate.NumberOfGuests } Person(s)`" :key="rate.NumberOfGuests" />-->
          <!--          </hm-col>-->
          <hm-col :grid="true" cols="12 6@desktop start-1">
            <template v-for="line in sortedLog">
              <template v-if="line.date === date">
                <label-value-dotted
                  :key="`${line.eventId}-${line.timestamp}`"
                  :value="line.inventory"
                  :label="`${ $options.filters.toLocalDateTime(line.eventTimestamp) } (Processed: ${ $options.filters.toLocalDateTime(line.timestamp) }) - ${ $options.filters.replaceIds(line.description) }`"
                  :value-class="[{'color--red': line.inventory < 0}]"
                  :clickable="!isEmpty(line.description) && line.description.includes('::')"
                  @click="openRecord(line.description)"
                />
              </template>
            </template>
          </hm-col>
        </hm-card-inner>
      </template>
    </card>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import { isEmpty, isNil, filter, map, uniq, debounce, sortBy } from 'lodash';
import HmFloatingButtons from '../../lib/inputs/HmFloatingButtons';
import HmFloatingButton from '../../lib/inputs/HmFloatingButton';
import Card from '../../lib/layout/Card';
import TabableCard from '../../lib/layout/TabableCard';
import TabableCardContent from '../../lib/layout/TabableCardContent';
import HmCol from '../../lib/layout/HmCol';
import HmCardInner from '../../lib/layout/HmCardInner';
import HmTable from '../../lib/table/HmTable';
import HmButton from '../../lib/buttons/HmButton';
import HmInputSelect from '../../lib/inputs/HmInputSelect';

export default {
  name: 'PageInventoryLog',
  components: { HmInputSelect, HmButton, HmTable, HmCardInner, HmCol, TabableCardContent, TabableCard, Card, HmFloatingButton, HmFloatingButtons },

  filters: {
    replaceIds: function (str) {
      const regex = /(hotel::[0-9]+::[a-zA-Z]+::([0-9]+))/gm;
      return str.replace(regex, '#$2');
    },
  },
  mixins: [HotelmeisterMixin, SaveWatchMixin],

  data() {
    return {
      updateLog: null,
      roomTypeId: null,
      startDate: null,
      endDate: null,
    };
  },

  computed: {
    dates() {
      const dates = [];
      const currDate = this.$moment(this.startDate, 'YYYYMMDD');
      const lastDate = this.$moment(this.endDate, 'YYYYMMDD');

      dates.push(currDate.clone().format('YYYY-MM-DD'));
      while (currDate.add(1, 'days').diff(lastDate) <= 0) {
        dates.push(currDate.clone().format('YYYY-MM-DD'));
      }

      return dates;
    },
    today() {
      return this.$moment().format('YYYYMMDD');
    },
    maxDate() {
      return this.$moment().add(730, 'days').format('YYYYMMDD');
    },
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
    sortedLog: function () {
      if (isNil(this.updateLog)) return [];
      return sortBy(this.updateLog, 'eventTimestamp').reverse();
    },
  },

  watch: {
  },

  created: function () {
    this.startDate = this.$moment().add(0, 'days').format('YYYYMMDD');
    this.endDate = this.$moment().add(0, 'days').format('YYYYMMDD');
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    isEmpty,
    loadData() {
      this.refreshUpdateLog();
    },
    refreshLog: debounce(
      function () {
        if (isEmpty(this.startDate) || isEmpty(this.endDate) || isEmpty(this.roomTypeId)) {
          this.updateLog = null;
          return;
        }
        this.axios.post(this.serviceUrls.inventoryLog(this),
          {
            roomTypeId: this.roomTypeId,
            startDate: this.startDate,
            endDate: this.endDate,
          })
          .then((response) => {
            this.updateLog = response.data.data;
          })
          .catch((error) => {
            if (isEmpty(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
          });
      },
      1000,
    ),
    openRecord(description) {
      if (isEmpty(description)) return;

      try {
        const reservationId = description.match(/(hotel::[0-9]+::res::[0-9]+)/gm)[0];
        this.$router.push({ name: 'reservation', params: { reservationId: reservationId } });
      } catch (ignore) { /* ignore */ }
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/PageInventoryLogs.vue